import React from "react";

// Language Data
import koData from "../../../data/works/ko.json";
import jaData from "../../../data/works/ja.json";
import enData from "../../../data/works/en.json";

// Components
import Tag from "../../Common/Tag/Tag";

// SCSS
import "./WorkWindow.scss";

const WorkWindow = ({ lang }) => {
  // Language
  const langFiles = { ko: koData, ja: jaData, en: enData };
  const currentData = langFiles[lang] || koData;

  return (
    <div className="WorkWindow">
      <div className="Overlay">
        <h3>Open for New Opportunities</h3>
      </div>
      {currentData.map((work) => (
        <section className="WorkItem" key={work.id}>
          <div className="WorkItem__Wrapper">
            <div className="WorkItem__Title">
              <h3 className="WorkItem__Title-Text">{work.date}</h3>
              {work.isCurrent && (
                <span className="WorkItem__Title-Badge">Current</span>
              )}
            </div>

            <div
              className="WorkItem__Detail"
              style={{ borderLeft: `4px solid #${work.color}` }}
            >
              <h4 className="WorkItem__Detail-Title">{work.title}</h4>
              <span className="WorkItem__Detail-Info">{work.info}</span>
              <p className="WorkItem__Detail-Desc">{work.desc}</p>

              <div className="WorkItem__Detail-Image">
                {work.images.map((imgSrc, index) => (
                  <img
                    key={index}
                    src={imgSrc}
                    alt={`${work.title} screen ${index}`}
                  />
                ))}
              </div>
              <div className="WorkItem__Detail-Skill">
                {work.skills.map((skillName) => (
                  <Tag key={skillName} text={skillName} />
                ))}
              </div>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default WorkWindow;
